import { useWebViewContentReady } from 'components/web_view/hooks'
import { useRefreshStats } from './lib/hooks'
import { registerFableScript } from 'app/webview/utils'

export const StatsProfileWVHandler = () => {
  useWebViewContentReady()
  const refresh = useRefreshStats()

  registerFableScript('refreshStats', refresh)

  return <></>
}
